import Joi from 'joi';
import type { IRecognitionResult } from './recognitionResult';
import { recognitionResultSchemaMap } from './recognitionResult';
import { actionCreator, objectSchemaOf } from '../helpers';

export const RESULT = 'VOICE_TO_TEXT/RESULT';

export interface IResultPayload extends IRecognitionResult {
  conversationId: string;
}

export const resultPayloadSchema = objectSchemaOf<IResultPayload>({
  ...recognitionResultSchemaMap,
  conversationId: Joi.string().required(),
});

export const resultActionSchema = objectSchemaOf<IResultAction>({
  type: Joi.string().required().valid(RESULT),
  payload: resultPayloadSchema.required(),
});

export interface IResultAction {
  type: typeof RESULT;
  payload: IResultPayload;
}

export const result = actionCreator({
  type: RESULT,
  schema: resultActionSchema,
});
